/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 */

import { useLocation } from 'react-router-dom'

export const usePathname = () => useLocation().pathname
